import { getToken } from '../../utils/token'
import {
  CancelOrderDocument,
  GetAllPaymentItemsDocument,
  GetOrderByIdDocument,
  IntentToPayDocument,
} from './generated/graphql'
import {
  createMutationHelper,
  createQueryHook,
  createRefetchQueryHelper,
  modifyQueryHook,
} from './utils'

export const useGetAllPaymentItems = modifyQueryHook(
  createQueryHook(GetAllPaymentItemsDocument, {
    // Disable cache to prevent query results with different promotionOption params
    // from being merged in cache, which causes price data corruption
    // (coupon prices get overwritten by non-coupon prices)
    fetchPolicy: 'no-cache',
  }),
  {
    reduce: r => r?.paymentItems,
  },
)

const refetchGetAllPaymentItemsInternal = createRefetchQueryHelper(
  GetAllPaymentItemsDocument,
)

export const refetchGetAllPaymentItems = () => {
  const tokenPresent = !!getToken()
  if (!tokenPresent) return
  return refetchGetAllPaymentItemsInternal()
}

export const useGetOrderById = modifyQueryHook(
  createQueryHook(GetOrderByIdDocument, { pollInterval: 5000 }),
  {
    transform: (orderId: string) => ({ orderId }),
    reduce: r => r?.order,
  },
)

export const [useIntentToPay, executeIntentToPay] =
  createMutationHelper(IntentToPayDocument)

export const [useCancelOrder, executeCancelOrder] =
  createMutationHelper(CancelOrderDocument)
